import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { IconCode02, IconPlus } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

import { ROUTES } from "@constants/routes";

const { CREATE } = ROUTES;

export default function SoftwareInventoryHeader() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const breadcrumbs = [
    {
      icon: <IconCode02 fill="dark" size="20" />,
    },
    {
      label: t("SOFTWARE_INVENTORY.HEADER"),
    },
  ];

  const headerText = {
    header: t("SOFTWARE_INVENTORY.HEADER"),
  };

  const actions = [
    <Button type="info" fill="fill" size="sm" onClick={() => navigate(CREATE)}>
      <IconPlus size="20" fill="light" />
      {t("SOFTWARE_INVENTORY.TABLE.ADD_BUTTON_TEXT")}
    </Button>,
  ];

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      actions={actions}
    />
  );
}
